import {FC} from 'react'
import {useFormContext, useFormState} from 'react-hook-form'
import {Body, BodyErrors, BodyItems, BodyNotes, Header, Row} from 'components/SearchForm/AdditionalSearchField'
import {SearchTextBox} from 'components/SearchForm/SearchTextBox'
import {Schema} from '../schema'

export const Projects: FC = () => {
  const {register, control} = useFormContext<Schema>()
  const {errors} = useFormState({control, name: 'projects'})

  return (
    <Row>
      <Header>プロジェクト</Header>
      <Body>
        <BodyItems>
          <SearchTextBox {...register('projects', {shouldUnregister: true})} style={{width: 400}} />
        </BodyItems>
        <BodyNotes>複数条件の場合はスペース区切りで入力してください</BodyNotes>
        <BodyErrors>{errors.projects && <p>{errors.projects.message}</p>}</BodyErrors>
      </Body>
    </Row>
  )
}
